import { useState, type FormEvent } from "react";

interface LoginScreenProps {
  busy: boolean;
  error: string | null;
  onLogin: (email: string, password: string) => Promise<void>;
}

export function LoginScreen({ busy, error, onLogin }: LoginScreenProps) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    await onLogin(email, password);
  }

  return (
    <main className="auth-page">
      <section className="auth-card" aria-labelledby="login-title">
        <div className="auth-brand">
          <span className="auth-logo" aria-hidden="true">▶</span>
          <div>
            <strong>KidTube</strong>
            <small>Parent Control</small>
          </div>
        </div>
        <div className="auth-copy">
          <p className="eyebrow">DÀNH CHO PHỤ HUYNH</p>
          <h1 id="login-title">Chào mừng trở lại</h1>
          <p>Đăng nhập để quản lý nội dung và thời gian xem trên hai TV của gia đình.</p>
        </div>
        {error !== null && <div className="alert error" role="alert">{error}</div>}
        <form className="auth-form" onSubmit={submit}>
          <label>
            Email
            <input
              type="email"
              name="email"
              autoComplete="username"
              inputMode="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              maxLength={254}
              disabled={busy}
            />
          </label>
          <label>
            Mật khẩu
            <input
              type="password"
              name="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
              minLength={8}
              maxLength={256}
              disabled={busy}
            />
          </label>
          <button type="submit" className="primary-button wide" disabled={busy}>
            {busy ? "Đang đăng nhập…" : "Đăng nhập"}
          </button>
        </form>
        <p className="auth-footnote">Tài khoản được tạo một lần khi triển khai. KidTube không mở đăng ký công khai.</p>
      </section>
      <div className="auth-visual" aria-hidden="true">
        <div className="visual-orbit orbit-one" />
        <div className="visual-orbit orbit-two" />
        <div className="visual-card visual-tv">
          <span>▶</span>
          <strong>Nội dung do bạn chọn</strong>
          <small>Không Shorts · Không đề xuất ngoài KidTube</small>
        </div>
      </div>
    </main>
  );
}
